export const canUseDOM = !!(
  typeof window !== 'undefined' && window.document && window.document.createElement
)



// WEBPACK FOOTER //
// ./history-3.3.0/modules/ExecutionEnvironment.js